import { PostSignaturePacketResponse } from 'QuoteApp/services/endpoints/PostSignaturePacket';
import {
  GetSignaturePacketSendAttemptResposne,
  transformGetSignaturePacketResponse,
} from 'QuoteApp/services/endpoints/GetSignaturePacketSendAttemptResposne';
import { useLazyBindApi } from 'Shared/services/Api';
import { useCallback, useState } from 'react';

export const useSignaturePacket = (appId: string) => {
  const [signaturePacketSendAttempt, setSignaturePacketSendAttempt] =
    useState<GetSignaturePacketSendAttemptResposne | null>(null);

  const [{ loading: sendSingnaturePacketInProgress }, _postSignaturePacket] =
    useLazyBindApi<PostSignaturePacketResponse>({
      method: 'POST',
      url: `/insurance_applications/${appId}/send_signature_packet`,
    });

  const [{ loading: loadingSignaturePacket }, _fetchSignaturePacket] =
    useLazyBindApi<GetSignaturePacketSendAttemptResposne>({
      method: 'GET',
      url: `insurance_applications/${appId}/signature_packet_send_attempt`,
    });

  const sendSignaturePacket = useCallback(
    async (sendLinkBySms: boolean) => {
      const response = await _postSignaturePacket({
        data: { send_link_by_sms: sendLinkBySms },
      });

      setSignaturePacketSendAttempt(response.data);

      return response.data;
    },
    [_postSignaturePacket]
  );

  const getSignaturePacket = useCallback(async () => {
    try {
      const response = await _fetchSignaturePacket();

      if (response.status === 204) {
        setSignaturePacketSendAttempt(null);
        return;
      } else {
        const responseData = transformGetSignaturePacketResponse(response.data);
        setSignaturePacketSendAttempt(responseData);
        return responseData;
      }
    } catch (error) {
      // We only keep 404 handler for backwards-compatibility until reznor is promoted to production
      if (error.response?.status === 404) {
        setSignaturePacketSendAttempt(null);
      }

      return;
    }
  }, [_fetchSignaturePacket]);

  return {
    sendSingnaturePacketInProgress,
    sendSignaturePacket,
    loadingSignaturePacket,
    getSignaturePacket,
    signaturePacketSendAttempt,
    setSignaturePacketSendAttempt,
  };
};
